!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("node-vibrant"), require("lodash.camelcase"), require("lodash.invoke"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "node-vibrant", "lodash.camelcase", "lodash.invoke", "react"], t) : t(e.reactPalette = {}, e.Vibrant, e.camelCase, e.invoke, e.react);
}(this, function (e, t, a, r, n) {
  t = t && t.hasOwnProperty("default") ? t.default : t, a = a && a.hasOwnProperty("default") ? a.default : a, r = r && r.hasOwnProperty("default") ? r.default : r, n = n && n.hasOwnProperty("default") ? n.default : n;
  var o = function o(e) {
      try {
        return Promise.resolve(t.from(e).getPalette()).then(function (e) {
          return Object.keys(e).reduce(function (t, n) {
            var o;
            return Object.assign({}, t, ((o = {})[a(n)] = r(e, [n, "getHex"]), o));
          }, {});
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    c = {
      loading: !0,
      data: {},
      error: void 0
    };
  function l(e, t) {
    switch (t.type) {
      case "getPalette":
        return c;
      case "resolvePalette":
        return Object.assign({}, e, {
          data: t.payload,
          loading: !1
        });
      case "rejectPalette":
        return Object.assign({}, e, {
          error: t.payload,
          loading: !1
        });
    }
  }
  function u(e) {
    var t = n.useReducer(l, c),
      a = t[0],
      r = t[1];
    return n.useEffect(function () {
      r({
        type: "getPalette"
      }), o(e).then(function (e) {
        r({
          type: "resolvePalette",
          payload: e
        });
      }).catch(function (e) {
        r({
          type: "rejectPalette",
          payload: e
        });
      });
    }, [e]), a;
  }
  var i = function i(e) {
    var t = e.children,
      a = u(e.src);
    return n.createElement(n.Fragment, null, t(a));
  };
  e.default = i, e.getPalette = o, e.Palette = i, e.usePalette = u;
});